import { render, staticRenderFns } from "./selaUserStats.vue?vue&type=template&id=1e4daaf5&scoped=true"
import script from "./selaUserStats.vue?vue&type=script&lang=js"
export * from "./selaUserStats.vue?vue&type=script&lang=js"
import style0 from "./selaUserStats.vue?vue&type=style&index=0&id=1e4daaf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4daaf5",
  null
  
)

export default component.exports